export function formatCurrency(p_value) {
    
    let value = '';

    if(p_value>0) value = new Intl.NumberFormat('es-CL', {currency: 'CLP'}).format(p_value);
    
    return value;

}